import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from "@angular/router";
import {MenuEditComponent} from "app/pages/menu-edit/menu-edit.component";
import {ModifierGroupComponent} from './modifier-group/modifier-group.component';
import {TranslateModule} from "@ngx-translate/core";
import { ModifierGroupItemComponent } from './modifier-group/modifier-group-item/modifier-group-item.component';
import { ModifierGroupModalComponent } from './modifier-group/modifier-group-modal/modifier-group-modal.component';
import {MatIconModule} from "@angular/material/icon";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatDialogModule} from "@angular/material/dialog";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FormsModule} from "@angular/forms";
import { SelectModifiersModalComponent } from './modifier-group/select-modifiers-modal/select-modifiers-modal.component';
import {MatTooltipModule} from "@angular/material/tooltip";
import {PreloaderModule} from "app/components/preloader/preloaderModule";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";

const routes: Routes = [
  {
    path: '',
    component: MenuEditComponent,
    children: [
      {path: 'modifier-group', component: ModifierGroupComponent, pathMatch: 'full'},
    ]
  },
];

@NgModule({
  declarations: [
    ModifierGroupComponent,
    ModifierGroupItemComponent,
    ModifierGroupModalComponent,
    SelectModifiersModalComponent
  ],
  exports: [
    ModifierGroupComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    TranslateModule,
    MatIconModule,
    MatFormFieldModule,
    MatDialogModule,
    MatCheckboxModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    MatTooltipModule,
    PreloaderModule,
    MatProgressSpinnerModule,
  ]
})
export class MenuEditModule {
}
